import { DiscountCategory } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { CombineDiscountWithField } from "./fields/combine-discount-with-field";
import { CustomerEligibilityField } from "./fields/customer-eligibility-field";
import { ExpirationField } from "./fields/expiration-field";
import { LimitOncePerCustomerField } from "./fields/limit-once-per-customer-field";
import { MaximumShippingPriceField } from "./fields/maximum-shipping-price-field";
import { MinimumPurchaseAmountField } from "./fields/minimum-purchase-amount-field";
import { MinimumQuantityField } from "./fields/minimum-quantity-field";
import { PurchaseTypeField } from "./fields/purchase-type-field";
import { ShippingCountriesField } from "./fields/shipping-countries-field";
import { ShowHiddenRecoverFieldsField } from "./fields/show-hidden-recover-fields-field";
import { StartDateTimeField } from "./fields/start-date-time-field";
import { TotalUsesField } from "./fields/total-uses-field";
import { DiscountSettingsSectionProps } from "./types";

export function ShopifyFreeShippingSettings({
  formState,
  category,
  showHiddenRecoverFields,
  setShowHiddenRecoverFields,
}: DiscountSettingsSectionProps) {
  const isRecover = category === DiscountCategory.RECOVER;
  const showRecoverGatedFields = !isRecover || showHiddenRecoverFields;

  return (
    <>
      <MaximumShippingPriceField
        setValue={formState.setMaximumShippingPrice}
        value={formState.maximumShippingPrice}
      />
      <ShippingCountriesField
        countryCodes={formState.freeShippingCountryCodes}
        setCountryCodes={formState.setFreeShippingCountryCodes}
      />
      <CombineDiscountWithField
        setValue={formState.setCombineDiscountWith}
        showProductDiscounts
        // Hide "Shipping discounts" option for Free Shipping discounts - combining shipping with shipping doesn't make sense
        showShippingDiscount={false}
        value={formState.combineDiscountWith}
      />
      <ExpirationField
        category={category}
        codeGenerationStrategy={formState.codeGenerationStrategy}
        expiration={formState.expiration}
        setExpiration={formState.setExpiration}
      />
      {!isRecover && (
        <StartDateTimeField
          setStartDate={formState.setStartDate}
          setStartTime={formState.setStartTime}
          startDate={formState.startDate}
          startTime={formState.startTime}
        />
      )}
      {showRecoverGatedFields && (
        <>
          <MinimumQuantityField
            setValue={formState.handleSetMinimumQuantity}
            value={formState.minimumQuantity}
          />
          <MinimumPurchaseAmountField
            setValue={formState.handleSetMinimumSubtotal}
            value={formState.minimumSubtotal}
          />
        </>
      )}
      {!isRecover && (
        <>
          <CustomerEligibilityField
            eligibility={formState.customerEligibility}
            onSegmentChange={formState.handleShopifySegmentChange}
            segmentOptions={formState.ShopifySegmentOptions}
            selectedCustomerIds={formState.selectedCustomerIds}
            selectedSegmentOptions={formState.selectedShopifySegmentOptions}
            setEligibility={formState.setCustomerEligibility}
            setSelectedCustomerIds={(customerIds) => {
              formState.setSelectedCustomerIdsString(customerIds.join(", "));
            }}
          />
          <TotalUsesField
            perCode={formState.perCodeDiscount}
            setUnlimited={formState.setUnlimitedUsage}
            setValue={formState.setTotalUsageLimit}
            unlimited={formState.unlimitedUsage}
            value={formState.totalUsageLimit}
          />
          <LimitOncePerCustomerField
            setValue={formState.setAppliesOncePerCustomer}
            value={formState.appliesOncePerCustomer}
          />
        </>
      )}
      <PurchaseTypeField
        purchaseType={formState.purchaseType}
        recurringCycleLimit={formState.recurringCycleLimit}
        setPurchaseType={formState.setPurchaseType}
        setRecurringCycleLimit={formState.setRecurringCycleLimit}
      />
      {isRecover && (
        <ShowHiddenRecoverFieldsField
          setValue={setShowHiddenRecoverFields}
          value={showHiddenRecoverFields}
        />
      )}
    </>
  );
}
